import { JSX } from "react";
import { useAppSelector } from "../../../app/hooks";
import { Button } from "@hatch-digital-nl/abs-storybook/legacy";

export const SubmitButtonComponent = (): JSX.Element => {
    const { rejectIsLoading } = useAppSelector((state) => state.review);

    return (
        <div
            className={
                "c-reject-certificate-modal__form-group c-reject-certificate-modal__form-group--button"
            }
        >
            <Button variant={"alert"} loading={rejectIsLoading} type={"submit"}>
                Certificaat afkeuren
            </Button>
        </div>
    );
};
